import { Link } from 'react-router-dom';

import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { Button } from '../ui/Button';

/**
 * CTA para nova selfie — sempre disponível.
 */
export function NewSelfieButton({
  label,
  variant = 'secondary',
  size = 'sm',
  className,
  icon: Icon = null,
}) {
  const text = label ?? pt.patrimonio.newSelfie;

  return (
    <Button asChild variant={variant} size={size} className={className}>
      <Link to={paths.selfieNew}>
        {Icon ? <Icon className="mr-1 h-4 w-4" aria-hidden /> : null}
        {text}
      </Link>
    </Button>
  );
}
